// extracted by mini-css-extract-plugin
export default {"videoHeader":"video-header_videoHeader__X5xc4","back":"video-header_back__2QGug","closeButton":"video-header_closeButton__qn6ta"};